import { render } from "./BrakePressureGauge.vue?vue&type=template&id=3cdf3e74&scoped=true"
import script from "./BrakePressureGauge.vue?vue&type=script&lang=js"
export * from "./BrakePressureGauge.vue?vue&type=script&lang=js"

import "./BrakePressureGauge.vue?vue&type=style&index=0&id=3cdf3e74&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdf3e74"]])

export default __exports__